export type TimePeriod = 'this-month' | 'this-year' | 'all-time';

export interface TimePeriodOption {
  id: TimePeriod;
  label: string;
}

export const TIME_PERIODS: TimePeriodOption[] = [
  { id: 'this-month', label: 'This Month' },
  { id: 'this-year', label: 'This Year' },
  { id: 'all-time', label: 'All Time' }
];

export const formatPeriodDisplay = (period: TimePeriod): string => {
  switch (period) {
    case 'this-month':
      return new Date().toLocaleDateString('en-US', { month: 'short' });
    case 'this-year':
      return new Date().getFullYear().toString();
    case 'all-time':
      return 'All Time';
    default:
      return 'All Time';
  }
};

export const formatPeriodTitle = (period: TimePeriod): string => {
  switch (period) {
    case 'this-month':
      return 'This Month';
    case 'this-year':
      return 'This Year';
    case 'all-time':
      return 'All Time';
    default:
      return 'All Time';
  }
};